import(/* webpackMode: "eager", webpackExports: ["default","error"] */ "/app/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/sliders/productSlider.tsx");
